import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./features/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./features/countries/countries.component').then((m) => m.CountriesComponent)
      },
      {
        path: 'countries/:countryCode',
        loadComponent: () =>
          import('./features/country-analytics/country-analytics.component').then((m) => m.CountryAnalyticsComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./features/users/user-search.component').then((m) => m.UserSearchComponent)
      },
      {
        path: 'users/:id',
        loadComponent: () => import('./features/users/user-detail.component').then((m) => m.UserDetailComponent)
      },
      {
        path: 'ads',
        loadComponent: () => import('./features/ads/ad-search.component').then((m) => m.AdSearchComponent)
      },
      {
        path: 'ads/:id',
        loadComponent: () => import('./features/ads/ad-detail.component').then((m) => m.AdDetailComponent)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];
